import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import PublicationCard from "../../components/publicationsCard/PublicationCard";
import "./Experience.css";
import { experience, publications } from "../../portfolio.js";
import { Fade } from "react-reveal";
import ExperienceImg from "./ExperienceImg";

class Experience extends Component {
  render() {
    const { theme, embedded } = this.props;
    const Root = embedded ? "section" : "div";
    const Content = embedded ? "div" : "main";
    const role = experience.sections[0].experiences[0];
    const entries = [
      {
        id: "government-role",
        name: role.title + " — " + role.company,
        date: role.duration,
        description: role.description,
        icon: "mdi:office-building-outline",
      },
      ...publications.data.filter(
        (project) => project.rating > 0 && project.reviewUrl
      ),
    ];

    return (
      <Root
        id={embedded ? "experience" : undefined}
        className={`experience-main site-scroll-section${
          embedded ? " embedded-section" : ""
        }`}
      >
        {!embedded && <Header theme={theme} />}
        <Content>
          <div className="basic-experience">
            <Fade bottom duration={750} distance="24px">
              <div className="experience-heading-div">
                <div className="experience-heading-img-div">
                  <ExperienceImg theme={theme} />
                </div>
                <div className="experience-heading-text-div">
                  <h1
                    className="experience-heading-text"
                    style={{ color: theme.text }}
                  >
                    {experience.title}
                  </h1>
                </div>
              </div>
            </Fade>
          </div>
          <div className="experience-unified-list">
            {entries.map((entry) => (
              <PublicationCard key={entry.id} pub={entry} theme={theme} />
            ))}
          </div>
        </Content>
        {!embedded && (
          <>
            <Footer theme={theme} />
            <TopButton theme={theme} />
          </>
        )}
      </Root>
    );
  }
}
export default Experience;
